import * as React from 'react';
import { st, classes } from './StripCard.st.css';
import { deprecationLog, wrap, unwrap } from '../../common/deprecationLog';
import { StripCardProps, StripCardDefaultProps } from './types';

export class StripCard extends React.Component<StripCardProps> {
  static displayName = 'StripCard';
  static MIN_WIDTH = 700;
  static defaultProps: StripCardDefaultProps = {
    roundMedia: false,
    sidePadding: true,
  };
  constructor(props) {
    super(props);
    wrap('Card');
  }

  componentDidMount(): void {
    deprecationLog(
      'StripCard',
      'The current `Card` component API will be deprecated in a future version. Please use the `upgrade` prop in order to use the new API.\nYou can view the new API here: https://wix-wix-ui-tpa.surge.sh/?path=/story/components--card',
    );
    unwrap('Card');
  }

  render() {
    const { media, info, roundMedia, sidePadding, className } = this.props;

    return (
      <div
        className={st(classes.root, { roundMedia, sidePadding }, className)}
        data-hook={this.props['data-hook']}
      >
        {media ? <div className={classes.mediaContainer}>{media}</div> : null}
        {info ? <div className={classes.infoContainer}>{info}</div> : null}
      </div>
    );
  }
}
